import React from 'react';

import { Service } from 'screens/shared';

const GasService = () => {
  const routes = {
    transOil: 'trans-oil',
    engineOil: 'engine-oil',
    currentError: 'current-error',
    inputStatus: 'input-status',
    outputStatus: 'output-status',
    machineInfo: 'machine-info',
    moduleInfo: 'module-info'
  };

  return <Service routes={routes} />;
};

export default GasService;



// WEBPACK FOOTER //
// ./src/screens/Gas/GasService/GasService.js